<template>
	<div>
		<v-data-table
		:headers="headers"
		:items="shipment_list"
		:hide-default-footer="true"
		:disable-sort="true"
		class="elevation-1 custome-header-bg custome-table-body"
		:loading="table_loading"
		>
		<template v-slot:item.retailer_firm_name="{ item }">
			<p>{{item.retailer_firm_name}}</p>
			<p>{{$lang.MOBILE_PREFIX}}{{item.retailer_mobile_number}}</p>
		</template>	
		<template v-slot:item.shipment_status="{ item }">
			<span  :class="getClassSatus(item.shipment_status)">{{item.shipment_status}}</span>
		</template>	
		<template v-slot:item.action="{ item }">
			<v-btn small fab text @click="gotoShipmentDetails(item.shipment_id)">	
				<img src="@/assets/arrow-right.svg" alt="">	
			</v-btn>	
		</template>	
	</v-data-table>

</div>
</template>

<script type="text/javascript">
export default {
	data () {
		return {
			table_loading:false,
			shipment_list:[],
			wholesaler_id:null,
			headers: [
			{ text: 'Shipment ID', align: 'start', value: 'shipment_id'},
			{ text: 'Retailer Info', value: 'retailer_firm_name' },
			{ text: 'Challan', value: 'challan_number' },
			{ text: 'Amount', value: 'shipment_amount' },
			{ text: 'Status', value: 'shipment_status' },
			{ text: '', value: 'action' },
			],
			/*FILTER*/
			filter_data:{
				retailer_id_list:[],
				status_list:[],
				type_list:[],
				filter_date_from:"",
				filter_date_to:"",
			}
		}
	},
	created(){
		/* receiving query params*/

		if(this.$route.query.wholesaler_id){
			this.wholesaler_id= this.decrypt(this.$route.query.wholesaler_id)
		}

		if(this.$route.query.type){
			this.$store.dispatch('setPageLoader', true)
			let withdrawal_list_type= this.decrypt(this.$route.query.type)
			this.getShipmentList(withdrawal_list_type)
		}

	},
	methods:{
		/* fetching shipment list */ 
		getShipmentList(withdrawal_list_type){
			const self=this

			let params={
				withdrawal_list_type:withdrawal_list_type,
				wholesaler_id_list:JSON.stringify([this.wholesaler_id]),
			};
			self.table_loading=true

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					this.shipment_list=response.data.shipment_list
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.WITHDRAWAL_SHIPMENT_LIST,params,successHandler,null,null,finallyHandler)
		},
		/* redirect to shipment details*/ 
		gotoShipmentDetails(shipment_id){
			this.$router.push({name:'shipment-details',params:{shipment_id:this.encript(shipment_id)}})
		},
	}
}


</script>